import { DatePipe } from "@angular/common";
import { CommissionEnum } from "@enums/commission";
import { CommissionType } from "@models/reports/reports";
import { Table } from "@models/table";
import { ProfileDataModalComponent } from "@pages/shared/reports/commissions-report/profile-data-modal/profile-data-modal.component";
import { formatNumberToLocal } from "src/app/utils/format-number-to-local";

const datePipe = new DatePipe('pt-BR');

export const FILTER_CONVERSION_BONUS: CommissionType = {
  id: CommissionEnum.CONVERSION_BONUS,
  description: 'Bônus conversão',
  startDateLabel: 'Data de pagamento inicial:',
  endDateLabel: 'Data de pagamento final:',
  filters: [
    {
      description: "Filtrar por: ",
      key: "filterBy",
      options: [
        { key: " ", value: "Sem filtro" }, 
        { key: "contract", value: "Contrato" },
      ]
    }
  ],
  componentModal: ProfileDataModalComponent
}

export const REPORT_CONVERSION_BONUS: Partial<Table<any>> = {
    headers: [
      { key: "contract", value: "Contrato" },
      { key: "group", value: "Grupo" },
      { key: "cota", value: "Cota" },
      { key: "version", value: "Versão" },
      { key: "sellerDocument", value: "CPF Vendedor" },
      { key: "assetValue", value: "Valor do Bem" },
      { key: "date", value: "Data da Venda" },
      { key: "personName", value: "Cliente" },
      { key: "installment", value: "Parcela" },
      { key: "percComission", value: "Percentual Comissão" },
      { key: "refundAmount", value: "Valor Estorno" },
      { key: "totalAmount", value: "Valor Total" },
    ],
    style: {
      table: {
        height: "500px",
      },
      data: [
        {
          key: "date",
          transform: (value) => datePipe.transform(value, "dd/MM/yyyy"),
        },
        {
          key: "assetValue",
          transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
        },
        {
          key: "refundAmount",
          transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
        },
        {
          key: "totalAmount",
          transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
        },
      ],
    },
    messageWithoutDates: "Nenhum dado encontrado para 'Bônus conversão'",
}
